import { WhichWeightAPI } from 'WhichWeightAPI'
import { useSelector } from 'react-redux'
import { useState, useEffect } from 'react'
import { GetDifficultyTextFromValue } from 'functions/textUtils'

import ScreenFrame from 'components/Frame/ScreenFrame'
import ContentFrame from 'components/Frame/ContentFrame'

export default function CompletedWorkoutSummary() {

    const userId = useSelector((state) => state.navigation.workoutSummaryParameters?.userId)
    const workoutId = useSelector((state) => state.navigation.workoutSummaryParameters?.workoutId)

    const [workoutExercises, setWorkoutExercises] = useState(null)
      
    const GetWorkoutExercisesFromBackend = async () => {       

        const jsonBody = {
            userId: userId,
            workoutId: workoutId
        }

        // console.log(jsonBody)

        const result = await WhichWeightAPI('CORE', 'GET', '/workout_summary', jsonBody)

        if (result.data.status === 'failure') {
            console.error(result)
            setWorkoutExercises([])
            return
        }

        // console.log(result.data.data)

        setWorkoutExercises(result.data.data)

    }

    useEffect(() => { GetWorkoutExercisesFromBackend() }, [])

    if (workoutExercises === null){
        return (
            <ScreenFrame>
                <div className='w-full h-[800px] bg-gray-200 rounded-lg animate-pulse' />
            </ScreenFrame>
        )
    }

    return (
        <ScreenFrame>
            <ContentFrame>
                {workoutExercises.length === 0 && (
                    <div className="p-4 text-center">No completed sets found for this workout</div>
                )}

                {workoutExercises.length > 0 && (
                    <table className="w-full divide-y divide-gray-200 bg-white">
                        <thead className='bg-gray-100'>
                            <tr className="text-left text-sm font-bold text-gray-900">
                                <th scope="col" className="py-2 pl-4">Exercise</th>
                                <th scope="col" className="py-2 px-4">Set</th>
                                <th scope="col" className="py-2 px-4">Weight</th>
                                <th scope="col" className="py-2 px-4">Completed</th>
                                <th scope="col" className="py-2">Difficulty</th>
                            </tr>
                        </thead>

                        <tbody className="divide-y divide-gray-200">
                            {workoutExercises.map((exercise) => (
                                <tr 
                                    key={exercise.id} 
                                    className="text-sm text-gray-500"
                                >
                                    <td className="pl-4 py-4 text-gray-900">{exercise.exerciseName}</td>

                                    <td className="px-4">{exercise.currentSet}/{exercise.setsAssigned}</td>

                                    {(exercise.exerciseType === 'recommendation' || exercise.exerciseType === '') && (
                                        <td className="px-4">{exercise.weightRecommendationRounded} lbs</td>
                                    )}

                                    {exercise.exerciseType === 'bodyweight' && 
                                        <td className="px-4">body weight</td>
                                    }

                                    <td className="px-4">
                                        {exercise.setUnitsCompleted}/{exercise.setUnitsAssigned} {exercise.setUnit}
                                    </td>

                                    <td className="pr-4">{GetDifficultyTextFromValue(exercise.difficulty)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </ContentFrame>
        </ScreenFrame>
    )
}
